<template>
    <v-card class="preaty__card pb-6" :style="showErrors && !stage.validate()? 'border: 2px solid rgba(220, 11, 11, 0.898)': 'border: 1px solid var(--v-primary_blue-base);'">
        <v-row class="pa-0 ma-0" v-if="stage">

            <v-col cols="9" class="px-4">
                <h3 class="text-h6">{{formatField(stage.name)}}</h3>
            </v-col>
            <v-col cols="2" class="px-4 text-right">
                Coste: <strong>{{stage.price}} créditos</strong>
            </v-col>
            <v-col cols="1" class="text-right py-1 pr-1">
                
                <v-btn icon @click="$emit('close-detail')">
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
            </v-col>
        </v-row>
        <div v-if="stage && stage.name == 'AskAI'" class="px-4">
            <AskAIDetailComponent :stage="stage" :showErrors="showErrors" :available_types="available_types" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'AddDocumentRepresentationToConversation'" class="px-4">
            <AddDocumentRepresentationToConversationDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage"/>
        </div>
        <div v-if="stage && stage.name == 'LookupAndMatchInstance'" class="px-4">
            <LookupAndMatchInstanceDetailComponent :stage="stage" :showErrors="showErrors" :available_types="available_types" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'LookupAndMatchMultipleInstances'" class="px-4">
            <LookupAndMatchMultipleInstancesDetailComponent :stage="stage" :showErrors="showErrors" :available_types="available_types" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'ExtractInstanceFromRawData'" class="px-4">
            <ExtractInstanceFromRawDataDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types"/>
        </div>
        <div v-if="stage && stage.name == 'CreateInstanceFromContext'" class="px-4">
            <CreateInstanceFromContextDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'CompleteConversation'" class="px-4">
            <CompleteConversationDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'SendEmailWithTemplate'" class="px-4">
            <SendEmailWithTemplateDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'SplitFile'" class="px-4">
            <SplitFileDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'RunCommand'" class="px-4">
            <RunCommandDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'RunQuery'" class="px-4">
            <RunQueryDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'RunWorkflow'" class="px-4">
            <RunWorkflowDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag" :availableWorkflows="availableWorkflows"/>
        </div>
        <div v-if="stage && stage.name == 'AddInstanceToList'" class="px-4">
            <AddInstanceToListDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'CreateInstance'" class="px-4">
            <CreateInstanceDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'CreateInstancesFromList'" class="px-4">
            <CreateInstancesFromListDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :available_types="available_types" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'ModifyContext'" class="px-4">
            <ModifyContextDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'SendThroughEmail'" class="px-4">
            <SendThroughEmailDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'PayrollAccounting'" class="px-4">
            <PayrollAccountingDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
        <div v-if="stage && stage.name == 'SendDataToEndpoint'" class="px-4">
            <SendDataToEndpointDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag" :available_types="available_types"/>
        </div>
        <div v-if="stage && stage.name == 'WaitForApproval'" class="px-4">
            <WaitForApprovalDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag" :available_users="available_users"/>
        </div>
        <div v-if="stage && stage.name == 'RunScript'" class="px-4">
            <RunScriptDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag" :available_types="available_types"/>
        </div>
        <div v-if="stage && stage.name == 'DeleteContextInstance'" class="px-4">
            <DeleteContextInstanceDetailComponent :stage="stage" :showErrors="showErrors" @compute-stage="computeStage" :my_bag="my_bag"/>
        </div>
    </v-card>
</template>

<script>
import { Stage } from '@/modules/document/domain/WorkflowTemplate';
import AskAIDetailComponent from '@/modules/document/infra/detail_components/AskAIDetailComponent';
import AddDocumentRepresentationToConversationDetailComponent from '@/modules/document/infra/detail_components/AddDocumentRepresentationToConversationDetailComponent';
import SendDataToEndpointDetailComponent from '@/modules/document/infra/detail_components/SendDataToEndpointDetailComponent';
import RunScriptDetailComponent from '@/modules/document/infra/detail_components/RunScriptDetailComponent';
import WaitForApprovalDetailComponent from '@/modules/document/infra/detail_components/WaitForApprovalDetailComponent';
import LookupAndMatchInstanceDetailComponent from '@/modules/document/infra/detail_components/LookupAndMatchInstanceDetailComponent';
import LookupAndMatchMultipleInstancesDetailComponent from '@/modules/document/infra/detail_components/LookupAndMatchMultipleInstancesDetailComponent';
import ExtractInstanceFromRawDataDetailComponent from '@/modules/document/infra/detail_components/ExtractInstanceFromRawDataDetailComponent';
import CreateInstanceFromContextDetailComponent from '@/modules/document/infra/detail_components/CreateInstanceFromContextDetailComponent';
import CompleteConversationDetailComponent from '@/modules/document/infra/detail_components/CompleteConversationDetailComponent';
import SendEmailWithTemplateDetailComponent from '@/modules/document/infra/detail_components/SendEmailWithTemplateDetailComponent';
import SplitFileDetailComponent from '@/modules/document/infra/detail_components/SplitFileDetailComponent';
import RunCommandDetailComponent from '@/modules/document/infra/detail_components/RunCommandDetailComponent';
import RunQueryDetailComponent from '@/modules/document/infra/detail_components/RunQueryDetailComponent';
import RunWorkflowDetailComponent from '@/modules/document/infra/detail_components/RunWorkflowDetailComponent';
import CreateInstanceDetailComponent from '@/modules/document/infra/detail_components/CreateInstanceDetailComponent';
import AddInstanceToListDetailComponent from '@/modules/document/infra/detail_components/AddInstanceToListDetailComponent';
import CreateInstancesFromListDetailComponent from '@/modules/document/infra/detail_components/CreateInstancesFromListDetailComponent';
import ModifyContextDetailComponent from '@/modules/document/infra/detail_components/ModifyContextDetailComponent';
import SendThroughEmailDetailComponent from '@/modules/document/infra/detail_components/SendThroughEmailDetailComponent';
import PayrollAccountingDetailComponent from '@/modules/document/infra/detail_components/PayrollAccountingDetailComponent';
import DeleteContextInstanceDetailComponent from '@/modules/document/infra/detail_components/DeleteContextInstanceDetailComponent';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";

export default {
    
    name:'WorkflowTemplateStageDetail',
    components: {
        AskAIDetailComponent,
        AddDocumentRepresentationToConversationDetailComponent,
        LookupAndMatchInstanceDetailComponent,
        LookupAndMatchMultipleInstancesDetailComponent,
        ExtractInstanceFromRawDataDetailComponent,
        CreateInstanceFromContextDetailComponent,
        AddInstanceToListDetailComponent,
        CompleteConversationDetailComponent,
        SendEmailWithTemplateDetailComponent,
        RunCommandDetailComponent,
        RunQueryDetailComponent,
        RunWorkflowDetailComponent,
        CreateInstanceDetailComponent,
        CreateInstancesFromListDetailComponent,
        ModifyContextDetailComponent,
        SendThroughEmailDetailComponent,
        PayrollAccountingDetailComponent,
        SendDataToEndpointDetailComponent,
        WaitForApprovalDetailComponent,
        RunScriptDetailComponent,
        SplitFileDetailComponent,
        DeleteContextInstanceDetailComponent
    },
    props:{
        stage: {
            type: Stage,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag: {
            type: Object,
            default: () => {}
        },
        available_users: {
            type: Array,
            default: () => []
        },
        availableWorkflows: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    /*border: 1px solid var(--v-primary_blue-base);*/
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>